import { FC, ReactElement } from 'react';

import { MODAL_TITLE } from '../constants';
import styles from './DetailsTitle.module.scss';

export interface IProps {
  eventLabel: string;
}

const DetailsTitle: FC<IProps> = ({ eventLabel }): ReactElement => (
  <div className={styles.modalTitle}>
    <span className={styles.titleEventBadge}>{eventLabel}</span>
    <span className={styles.titleText}>{MODAL_TITLE}</span>
  </div>
);

export default DetailsTitle;
